













import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class MaskableInputComponent extends Vue {
  @Prop(String) mask!: string;
  @Prop(String) value!: string;
  @Prop(Boolean) disabled!: boolean;
  @Prop(Boolean) hasError!: boolean;

  valueChanged(value: any) {
    this.$emit('change', value);
  }
}
